

import vueTape from 'vue-tape';

const watchCallbacks = {}

export function commitState(state) {
    Object.keys(state).forEach((key) => {
        vueTape.state.set(key, state[key]);
        if (watchCallbacks[key]) {
            (watchCallbacks[key] || []).forEach(callback => {
                callback && callback();
            })
        }
    })
}

export function readState(key, def) {
    return vueTape.state.get(key, def);
}

export function onWatchState(key, callback) {
    let callbacks = watchCallbacks[key] || [];
    if (callbacks.indexOf(callback) < 0) {
        callbacks.push(callback);
    }
    watchCallbacks[key] = callbacks;
}

export function offWatchState(key, callback) {
    let callbacks = watchCallbacks[key] || [];
    let indexOf = callbacks.indexOf(callback);
    if (indexOf >= 0) {
        callbacks.splice(indexOf, 1);
    }
    watchCallbacks[key] = callbacks;
}

export default {
    username: '',
    customerUsername: "",
    accessToken: '',
    accessLoggedIn: false,
    userProfile: {},
    clientCollapse: false,
    clientFullScreen: false,
    globalWebSiteConfig: null,
    curStoreGuid: "",
    curStorehouseGuid: "",
    unmannedApiType: "",
    storeCartData: null
}
